module.exports = __webpack_public_path__ + "static/img/join_banner.56371ec.56371ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/join_banner.56371ec.png
// module id = u+D/
// module chunks = 1